import { Component, inject, OnInit } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {RegistrationDialogComponent} from './registration-dialog/registration-dialog.component';
import {HttpClient} from '@angular/common/http';
import {LoginDialogComponent} from './login-dialog/login-dialog.component';
import {LocalStorageService} from '../../../api/services/localStorage';
import {LoggedUser} from '../../types/loggedUser';
import {Router} from '@angular/router';
import { NavigationService } from './services/navigation-bar.service';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})
export class NavigationBarComponent implements OnInit {

  loggedUser = new LoggedUser();
  loggedIn = false;

  protected opened = false;

  /** Navigation service reference */
    private service = inject(NavigationService);

  constructor(public dialog: MatDialog, private router: Router, private http: HttpClient, private localStorage: LocalStorageService) {
    this.service.closeSideNav.subscribe(() => {
      this.closeSideNav();
    });
  }

  ngOnInit(): void {
    if (this.localStorage.get('loggedUser') !== null) {
      this.loggedUser = this.localStorage.get('loggedUser') as LoggedUser;
      this.loggedIn = true;
    }
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(RegistrationDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openLoginDialog(): void {
    const dialogRef = this.dialog.open(LoginDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  onGoHome(): void {
    this.opened = false;
    this.router.navigate(['/home']);
  }

  onLogout(): void {
    this.localStorage.remove('loggedUser');
    window.location.reload();
  }

  handleSideNav(): void {
    this.opened = !this.opened;
  }

  closeSideNav(): void {
    this.opened = false;
  }
}
